import {useContext } from "react";
import Loader from "../components/loader";
import { Modal } from "antd";
import { MyContext } from "../MyContext/MyProvider";

const LoaderModal = () => {
  const {isLoading} =  useContext(MyContext);
  return (
    <Modal
      open={isLoading}
      //   onOk={handleOk}
      className="remove-modal loader-modal"
      centered={true}
      width="35%"  
    >
      <div className="modal-content">
        <Loader />
      </div>
    </Modal>
  );
};

export default LoaderModal;
